import { ThirdPartyTypeEnum } from '@e-socna/data-layer';

import type { FolderBusinessEntityListCmp_ThirdParty } from '../fragments/third-party.fragment';

export const getThirdPartyName = (
  thirdParty: FolderBusinessEntityListCmp_ThirdParty,
) => {
  switch (thirdParty.__typename) {
    case 'Organization':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Organization:
      return thirdParty.name;
    case 'Person':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Person:
      return thirdParty.fullName;
    default:
      throw new Error('Unknown third party type');
  }
};
